import React from 'react';
import { Globe2, MousePointer2, Video } from 'lucide-react';
import CompanionsGlobe from './CompanionsGlobe';
import CompanionsHeroCopy from './CompanionsHeroCopy';
import type { CompanionCity, CompanionRegionFilter, GlobeArc, GlobePoint } from './types';

type CompanionsHeroSectionProps = {
  activeCity: CompanionCity;
  activeCityId: string;
  activeRegion: CompanionRegionFilter;
  filteredCities: CompanionCity[];
  totalCompanions: number;
  filteredCount: number;
  onRegionChange: (region: CompanionRegionFilter) => void;
  onSelectCityId: (cityId: string) => void;
  pointData: GlobePoint[];
  arcData: GlobeArc[];
  onSelectCity: (city: CompanionCity | null | undefined) => void;
  onOpenVideo: (city: CompanionCity) => void;
  onScrollToStories: () => void;
};

const CompanionsHeroSection: React.FC<CompanionsHeroSectionProps> = ({
  activeCity,
  activeCityId,
  activeRegion,
  filteredCities,
  totalCompanions,
  filteredCount,
  pointData,
  arcData,
  onRegionChange,
  onSelectCityId,
  onSelectCity,
  onOpenVideo,
  onScrollToStories,
}) => (
  <section className="relative overflow-hidden border-b border-slate-200/60">
    <div className="companions-page__mesh companions-page__grid-bg pointer-events-none absolute inset-0" />

    <div className="companions-hero-pair relative mx-auto max-w-7xl px-4 py-10 sm:px-8 sm:py-14">
      <CompanionsGlobe
        activeCity={activeCity}
        pointData={pointData}
        arcData={arcData}
        onSelectCity={onSelectCity}
      />

      <CompanionsHeroCopy
        activeCity={activeCity}
        activeCityId={activeCityId}
        activeRegion={activeRegion}
        filteredCities={filteredCities}
        totalCompanions={totalCompanions}
        filteredCount={filteredCount}
        onRegionChange={onRegionChange}
        onSelectCity={onSelectCityId}
        onOpenVideo={onOpenVideo}
        onScrollToStories={onScrollToStories}
      />
    </div>

    <div className="relative mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-4 border-t border-slate-200/50 bg-white/40 px-4 py-3.5 text-[11px] font-bold text-slate-500 backdrop-blur-sm sm:px-8 lg:justify-between">
      <span className="inline-flex items-center gap-2">
        <Globe2 className="h-3.5 w-3.5 text-[var(--cp-brand)]" />
        نقشه تعاملی همراهان جهانی
      </span>
      <span className="hidden h-4 w-px bg-slate-200 md:block" />
      <span className="inline-flex items-center gap-2">
        <Video className="h-3.5 w-3.5 text-[var(--cp-accent)]" />
        ویدیوهای تجربهٔ کاربران
      </span>
      <span className="hidden h-4 w-px bg-slate-200 md:block" />
      <span className="inline-flex items-center gap-2">
        <MousePointer2 className="h-3.5 w-3.5 text-[var(--cp-violet)]" />
        کره را بچرخانید · روی هر شهر کلیک کنید
      </span>
    </div>
  </section>
);

export default CompanionsHeroSection;
